const getPreparedRmaStatusOptions = (rmaStatusOptions) => {
    return rmaStatusOptions
        .filter(([_, label]) => !['In Process', 'Pending Approval', 'Rejected'].includes(label))
        .map(([value, label]) => ({ label, value }));
};
export default getPreparedRmaStatusOptions;
